import { ChildCandidate } from "store/candidate/types";

export const getUsername = (candidate: ChildCandidate) => {
  if (candidate.hasFamilyName)
    return `${candidate.otherNames} ${candidate.familyName}`;

  return `${candidate.otherNames}`;
};

